/**
* @Author: Roxy Chen
* @Date:   2016-08-20T15:40:40+08:00
* @Last modified by:   Roxy Chen
* @Last modified time: 2016-08-21T14:40:48+08:00
* @License: Copyright (c) by Giftpack Inc. All Rights Reserved.
*/


import React, { Component } from "react";
import AnimateEffect from "../../tool/animateEffect";
import PropTypes from "prop-types";


export const Navigator =  class Desktop extends Component {
  static propTypes = {
    onTop: PropTypes.bool,
  };
  static defaultProps = {
    onTop: true
  }
  constructor(props){
    super(props)
  }
  render(){
    const { onTop } = this.props;
    return(
      <div className={ onTop ? "navbar-container vertical-flex-item" : "navbar-container vertical-flex-item fixed"}>
      {/*!onTop && (<span className="brand-text">TAIWAN INTELLIGENT HOME</span>)*/}
        <div className={ onTop ? "navbar flex-row" : "navbar flex-row fixed"}>
          <div className="navgator link flex-row" >
            <AnimateEffect trigger={true} effect={"fadeInDown"} delay={600} ><a href="../" className="link-white" >HOME</a><span className="underline"/></AnimateEffect>
            <AnimateEffect trigger={true} effect={"fadeInDown"} delay={200} ><a href="https://github.com/tihtw" target="_blank"  className="link-white">DEVELOPER</a><span className="underline"/></AnimateEffect>
            <AnimateEffect trigger={true} effect={"fadeInDown"} delay={600} ><a href="./supported-brands" className="link-white">BRANDS</a><span className="underline"/></AnimateEffect>
            <AnimateEffect trigger={true} effect={"fadeInDown"} delay={800} ><a href="https://medium.com/@tih/" target="_blank" className="link-white">MEDIUM</a><span className="underline"/></AnimateEffect>
          </div>
          <div className="navgator login flex-row tempHide" >
            <div className={ onTop ? "login-btn" : "" }><a href="login.html">Login</a></div>
          </div>
        </div>
      </div> )
  }
}

export const MobileNav = class Mobile extends Component {

  constructor(props){
    super(props)
    this.state = {
      open: false
    }
  }
  unFold(){
    !this.state.open ? this.setState({open:true}) : this.setState({open:false});
  }
  render(){
    return(
      <div>
        <div onClick={()=>this.unFold()} className={this.state.open ? "nav-btn active": "nav-btn"} >
          <span className="nav-btn-line"/>
          <span className="nav-btn-line"/>
          <span className="nav-btn-line"/>
        </div>
        <div className={ this.state.open ? "navbar-container-m active" : "navbar-container-m"}>
          <div className="navbar flex-column">
            <div className="navgator link flex-column" >
              <AnimateEffect trigger={this.state.open} effect={"fadeInDown"} delay={400} ><a href="../"  className="link-white">HOME</a></AnimateEffect>
              <AnimateEffect trigger={this.state.open} effect={"fadeInDown"} delay={200} ><a href="https://github.com/tihtw" target="_blank"  className="link-white">DEVELOPER</a></AnimateEffect>
              <AnimateEffect trigger={this.state.open} effect={"fadeInDown"} delay={600} ><a href="./supported-brands" className="link-white">BRANDS</a></AnimateEffect>
              <AnimateEffect trigger={this.state.open} effect={"fadeInDown"} delay={800} ><a href="https://medium.com/@tih/" target="_blank" className="link-white">MEDIUM</a></AnimateEffect>
            </div>
            <div className="navgator login flex-column tempHide" >
              <div><a href="./login" className="link-white">Login</a></div>
            </div>
          </div>
          <span className="brand-text ">TAIWAN INTELLIGENT HOME</span>
        </div>
      </div>
     )
  }
}
